import React from "react";
import Container from "@mui/material/Container";
import Typography from "@mui/material/Typography";
import TextField from "@mui/material/TextField";
import Button from "@mui/material/Button";
import Alert from '@mui/material/Alert';
import FormControlLabel from "@mui/material/FormControlLabel";
import Checkbox from "@mui/material/Checkbox";
import { withRouter } from "react-router";
import { Link } from "react-router-dom";
import { Trans } from "react-i18next";

import NavBar from "../components/NavBar";
import Footer from "../components/Footer";
import axios from "../components/Axios";
import { clearCdnCookie } from "../app/cdnCookie";
import { nextAfterLogin } from "../components/PrivateRoute";
import "./Login.css";

class Index extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      loading: false,
      errorMessage: "",
      email: "",
      password: "",
      remember: false,
    };
    this.handleChange = this.handleChange.bind(this);
    this.login = this.login.bind(this);
  }

  componentDidMount() {
    //remember
    let r = localStorage.getItem("remember");
    if (r !== null) {
      this.setState({ email: r, remember: true });
    }
  }

  handleChange(e) {
    this.setState({ [e.target.name]: e.target.value });
  }
  rememberChange(e) {
    this.setState({ remember: e.target.checked });

    //forget
    if (!e.target.checked) {
      localStorage.removeItem("remember");
    }
  }

  login(e) {
    e.preventDefault();
    this.setState({ loading: true, errorMessage: "" });
    axios
      .post("/login", this.state)
      .then(
        function (response) {
          //this.setState({items: response.data});
          if ("error_code" in response.data) {
            this.setState({
              loading: false,
              errorMessage: response.data.message,
            });
          } else {
            this.setState({ loading: false });
            localStorage.setItem("token", response.data.api_access_token);
            localStorage.setItem("user_id", response.data.user_info.user_id);
            localStorage.setItem(
              "user",
              JSON.stringify(response.data.user_info)
            );

            //remember me
            if (this.state.remember) {
              localStorage.setItem("remember", response.data.user_info.email);
            }
            //axios.defaults.headers.common['Authorization'] = AUTH_TOKEN;
            clearCdnCookie(); // a CDN cookie set in this tab may be another user's
            // back to the page that sent the user here (?next=), else the library
            window.location.replace(nextAfterLogin(window.location.search));
            //this.props.history.push("/");
          }
        }.bind(this)
      )
      .catch(
        function (error) {
          const status = error.response ? error.response.status : 0;
          if (status === 401) {
            this.setState({ errorMessage: "Invalid email or password" });
          } else if (status === 0) {
            // no answer: offline, or the API is down
            this.setState({ errorMessage: "Can't reach VideoViews. Check your connection and try again." });
          } else if (status === 500) {
            this.setState({ errorMessage: error.response.data.message });
          } else {
            this.setState({ errorMessage: "Unknown Error" });
          }
          this.setState({ loading: false });
        }.bind(this)
      );
    return false;
  }

  render() {
    return (
      <div
        className="background"
        style={{ display: "flex", flexDirection: "column" }}
      >
        <NavBar />
        <Container maxWidth="xs" style={{ marginTop: "64px", flex: "1" }}>
          <Typography variant="h5" gutterBottom className="loginTitle">
            <Trans>Login to VideoViews</Trans>
          </Typography>

          <p className="loginText">
            <Trans>Enter your details below</Trans>
          </p>
          <form onSubmit={this.login}>
            <label
              htmlFor="email"
              style={{ color: "#063e6c", fontWeight: "bold" }}
            >
              <Trans>Email address</Trans>
            </label>
            <br />
            <TextField
              name="email"
              id="email"
              variant="outlined"
              size="small"
              value={this.state.email}
              onChange={this.handleChange}
              type="email"
              autoFocus
              required
              fullWidth
            />
            <br />
            <br />
            <label
              htmlFor="password"
              style={{ color: "#063e6c", fontWeight: "bold" }}
            >
              <Trans>Password</Trans>
            </label>
            <br />
            <TextField
              name="password"
              id="password"
              variant="outlined"
              size="small"
              value={this.state.password}
              onChange={this.handleChange}
              required
              fullWidth
              type="password"
            />

            <a
              style={{
                color: "#1355B2",
                margin: "8px 0",
                fontSize: "12px",
                display: "block",
              }}
              href="/forgotpw"
            >
              <Trans>Forgot your password?</Trans>
            </a>
            {this.state.errorMessage !== "" && (
              <Alert
                severity="error"
                onClose={() => {
                  this.setState({ errorMessage: "" });
                }}
              >
                {this.state.errorMessage}
              </Alert>
            )}
            <div
              style={{
                display: "flex",
                alignItems: "center",
                justifyContent: "space-between",
                margin: "32px 0",
              }}
            >
              <div>
                <FormControlLabel
                  control={
                    <Checkbox
                      checked={this.state.remember}
                      color="primary"
                      className="CheckBox"
                      onChange={this.rememberChange.bind(this)}
                    />
                  }
                  label={<Trans>Remember me</Trans>}
                />
              </div>
              <Button
                className="Button ButtonPrimary"
                size="small"
                type="submit"
                disabled={this.state.loading}
              >
                <Trans>Log In</Trans>
              </Button>
            </div>
          </form>

          <div className="registerBox">
            <div>
              <Trans>Don't have an account?</Trans>{" "}
              <Link to="/register" style={{ textDecoration: "underline" }}>
                <Trans>Sign up for a free trial.</Trans>
              </Link>
            </div>
          </div>
        </Container>
        <Footer></Footer>
      </div>
    );
  }
}

export default withRouter(Index);
